// Member portal calls for High Holiday 5787 attendance and member-rate
// guest seats. Every call carries the signed-in member's ID token; the
// backend resolves the uid from it, never from anything we send.
import { authedFetch } from '../authedFetch';

const readJson = async (res, fallback) => {
  const json = await res.json().catch(() => ({}));
  // `msg || message` matches src/api/membership/membershipApi.js. The
  // backend's own messages are worth surfacing — e.g. the allowance
  // rejection tells the member exactly why their seat count was refused —
  // and checking only one field would replace it with a generic string.
  if (!res.ok) throw new Error(json.msg || json.message || `${fallback} (${res.status})`);
  return json;
};

export const getHighHolidays = async () =>
  readJson(await authedFetch('/me/high-holidays'), 'Could not load your High Holiday details');

export const confirmAttendance = async ({ attending, menSeatNames, womenSeatNames }) =>
  readJson(
    await authedFetch('/me/high-holidays/attendance', {
      method: 'POST',
      body: JSON.stringify({ attending, menSeatNames, womenSeatNames }),
    }),
    'Could not save your attendance'
  );

export const createExtraSeatsIntent = async (hhSeats) =>
  readJson(
    await authedFetch('/me/high-holidays/extra-seats-intent', {
      method: 'POST',
      body: JSON.stringify({ hhSeats }),
    }),
    'Could not start your seat purchase'
  );

// Named before exporting: `export default { ... }` trips
// import/no-anonymous-default-export, and CI=true turns CRA's eslint
// warnings into build errors. It went unnoticed until MyAccount.js
// imported this module, which is what pulled it into the build's lint
// graph in the first place. Every call site uses the named exports.
const highHolidaysApi = { getHighHolidays, confirmAttendance, createExtraSeatsIntent };

export default highHolidaysApi;
